const dev = {  	
	//   API_ENDPOINT_URL:  'https://bloomberry.gendialer.voiceracx.ai/vdl/',
	  API_ENDPOINT_URL: 'http://localhost:1010/vdl/',
	//   API_ENDPOINT_URL: 'https://43.106.3.118/vdl/',
	//    API_ENDPOINT_URL: 'https://43.106.18.198/vdl/',
	
	   AI_API_URL: 'https://vlmmini.voicera-analytics.com/',
	   VLM_UI_URL: 'https://vlmui.voiceracx.ai',
	
}

const prod = {
	//For Production
	  API_ENDPOINT_URL: 'https://bloomberry.gendialer.voiceracx.ai/vdl/',

	 //For QA
	//    API_ENDPOINT_URL:  'https://43.106.3.118/vdl/',
	    //  API_ENDPOINT_URL: 'http://localhost:1010/vdl/',

	   AI_API_URL: 'https://vlmmini.voicera-analytics.com/',
	   VLM_UI_URL: 'https://vlmui.voiceracx.ai',
};


const getEnv = () => {
	switch (process.env.NODE_ENV) {
		case 'development':
			return dev
		case 'production':
			return prod
		
		default:
			break;
	}
}

export const env = getEnv()
